import { render, staticRenderFns } from "./selectUnit.vue?vue&type=template&id=284ed8db&scoped=true"
import script from "./selectUnit.vue?vue&type=script&lang=js"
export * from "./selectUnit.vue?vue&type=script&lang=js"
import style0 from "./selectUnit.vue?vue&type=style&index=0&id=284ed8db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284ed8db",
  null
  
)

export default component.exports